import { Box, Text } from "@mantine/core";

type ExpoVisitorHeaderCopyProps = {
  title: string;
  description?: string;
};

/** Compact title + subtitle for the expo visitor AppShell header. */
export function ExpoVisitorHeaderCopy({ title, description }: ExpoVisitorHeaderCopyProps) {
  return (
    <Box style={{ minWidth: 0, flex: 1 }}>
      <Text fw={600} fz={{ base: 16, sm: 18 }} c="#04305c" truncate lh={1.2}>
        {title}
      </Text>
      {description ? (
        <Text size="xs" c="slate.7" truncate lh={1.3} mt={2}>
          {description}
        </Text>
      ) : null}
    </Box>
  );
}
